import React from 'react'
import styles from './MicrositeKpiCard.module.css'
import { TrendingUp, TrendingDown } from 'lucide-react'

/**
 * MicrositeKpiCard
 * Single KPI: icon, large value, label, optional trend indicator.
 * Used across MicrositeAnalytics and MicrositeConversions.
 *
 * Usage:
 *   <MicrositeKpiCard icon={TrendingUp} label="Total page views" value={4820} />
 *
 *   <MicrositeKpiCard
 *     icon={MousePointerClick}
 *     label="CTA clicks"
 *     value={180}
 *     trend={{ direction: 'up', value: '+12%' }}
 *   />
 */
const MicrositeKpiCard = ({ icon: Icon, label, value, trend }) => (
    <div className={styles.card}>
        {Icon && (
            <div className={styles.iconWrap}>
                <Icon size={16} />
            </div>
        )}
        <div className={styles.textCol}>
            <div className={styles.value}>{value}</div>
            <div className={styles.labelRow}>
                <span className={styles.label}>{label}</span>
                {trend && (
                    <span className={`${styles.trend} ${trend.direction === 'up' ? styles.trendUp : styles.trendDown}`}>
                        {trend.direction === 'up' ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
                        {trend.value}
                    </span>
                )}
            </div>
        </div>
    </div>
)

export default MicrositeKpiCard